import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  logoImage, 
  payPassIcon, masterCardIcon, 
  verifiedByVisaIcon, visaIcon,
} from 'assets/images';

import { Button, Image } from 'components';
import { LinksSocialFooter } from './LinksSocialFooter';
import { LinksPlatformsFooter } from './LinksPlatformsFooter';
import { LinksOthers } from './LinksOthers';
import { linksOthers, linksOthers2 } from './constants';
import { links } from '../Header/constants';

import styles from './styles.module.scss';

export const Footer = memo(() => {
  const { t } = useTranslation('footer');
  const nowYear = new Date().getFullYear();
  
  const paymentIcons = [payPassIcon, masterCardIcon, verifiedByVisaIcon, visaIcon];
  const renamedLinks = links.map(({ title, pathName }) => ({
    title,
    link: pathName,
  }));

  const handleLogoClick = () => {
    window.open('https://eclipse.club/', '_blank');
  };

  return (
    <div className={styles.footer_container}>
      <Button
        onClick={handleLogoClick}
        className={styles.footer_logo_button}
      >
        <Image
          url={logoImage}
          className={styles.footer_container_logo}
        />
      </Button>

      <LinksSocialFooter />

      <div className={styles.footer_links}>
        <div className={styles.footer_links_column}>
          <LinksOthers
            links={renamedLinks}
            isHeaderLink
          />
        </div>
        <div className={styles.footer_links_column}>
          <LinksOthers
            links={linksOthers}
          />
        </div>
        <div className={styles.footer_links_column}>
          <LinksOthers
            links={linksOthers2}
          />
        </div>
      </div>

      <div className={styles.footer_info}>
        <div className={styles.footer_copyright}>
          {t('Copyright_', { nowYear })}
        </div>

        <LinksPlatformsFooter />

        <div className={styles.footer_pays}>
          {paymentIcons.map((icon, index) => (
            <Image
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              url={icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
});
